export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/DatabaseWorker.b4c76bce.worker.js");
}
